import { QueryClientProvider } from "@tanstack/react-query"
import { ErrorBoundary } from "react-error-boundary"
import type { ReactNode } from "react"
import { Toaster } from "sonner"

import { ErrorFallback } from "@/components/common/error-fallback"
import { queryClient } from "@/lib/query-client"

interface AppProviderProps {
  children: ReactNode
}

export function AppProvider({ children }: AppProviderProps) {
  return (
    <ErrorBoundary
      FallbackComponent={ErrorFallback}
      onReset={() => queryClient.clear()}
    >
      <QueryClientProvider client={queryClient}>
        <>
          <Toaster richColors position="top-right" />
          {children}
        </>
      </QueryClientProvider>
    </ErrorBoundary>
  )
}